import React from "react";
import {
  Box,
  Text,
  VStack,
  Button,
  Image,
  useBreakpointValue,
} from "@chakra-ui/react";
import badge from "../../../assets/home/badgered.png"; // Replace with actual image path
import handPointer from "../../../assets/home/handpointer.png"; // Optional: hand pointer icon if needed

const JoinTheTeam = () => {
  const imageSize = useBreakpointValue({ base: "60px", md: "80px" });

  return (
    <Box w="100%" display="flex" justifyContent="center" py={12} bg="white">
      <Box
        bg="#C1A882"
        w={{ base: "90%", md: "80%", lg: "75%" }}
        py={{ base: 10, md: 16 }}
        px={4}
        borderRadius="md"
        textAlign="center"
        position="relative"
      >
        <VStack spacing={4}>
          <Text
            fontSize={{ base: "lg", md: "2xl" }}
            fontWeight="bold"
            color="white"
            className="fade-in-up"
          >
            Join The <Text as="span" fontStyle="italic" color="white" className="fade-in-up">Team</Text>
          </Text>

          <Text fontSize={{ base: "sm", md: "md" }} color="white" className="fade-in-up">
            Be a part of the Jugadu revolution – Join the team today!
          </Text>

          {/* Button */}
          <Box position="relative" display="inline-block">
          <Button
            colorScheme="teal"
            bg="#005770"
            color="white"
            px={8}
            py={6}
            borderRadius="xl"
            fontWeight="semibold"
            fontSize={{ base: 'sm', md: 'md' }}
            _hover={{ bg: '#007ca6' }}
          >
            Join Team
          </Button>

          {/* Hand Pointer */}
          <Image
            src={handPointer}
            alt="Hand Pointer"
            boxSize={{ base: '25px', md: '30px' }}
            position="absolute"
            right={{ base: '-2', md: '-4' }}
            bottom={{ base: '-2', md: '-4' }}
          />
        </Box>

          {/* Badge Image */}
          <Box>
            <Image src={badge} alt="Badge" left="60%" boxSize={imageSize} data-animated = 'true'/>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};

export default JoinTheTeam;
